import { connect } from 'react-redux'
import { loadNotes } from '../../../actions/imi'
import { MarketReportsWidget } from './MarketReportsWidget.component'

const mapStateToProps = (state) => {
  return {
    notes: state.imi.notes,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadNotes: (id) => dispatch(loadNotes(id))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MarketReportsWidget)



// WEBPACK FOOTER //
// ./src/features/commons/MarketReportsWidget/MarketReportsWidget.container.js